/*******************************************************************************
 * $Id: ClassInfo.js 20552 2020-11-28 21:48:55Z sthames $ */
/**
 * @ngdoc    object
 * @name     ClassInfo
 * @module   csm.books.InitialSetup.services.Data.books
 * @constructor
 * @param {object=} info  Class info read from database.
 * @description
 * Class information.
 *******************************************************************************/
/* @ngInject */ export function classInfoConfig(TypeFactoryProvider) {
  /*------------------------------------------*/
  /* Using defaults rather than prototype to  */
  /* make sure default values get serialized. */
  /*------------------------------------------*/
  var defaults = {
    id: 0, // Class ID.
    organizationID: 0, // Organization ID.
    type: 0, // Class Type. Read-Only
    name: null, // Class Name.
    active: true // Active.
  };

  TypeFactoryProvider.addType({
    name: 'Data.books.ClassInfo',
    $type: 'csm.booksdb.data.ClassInfo, CSMBooksDBCS',
    constructor: function () {
      return function (data) {
        this.defaultConstructor(Object.assign({}, defaults, data));
      };
    }
  });
};
